/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type NotesWidgetContainer_user$ref: FragmentReference;
export type NotesWidgetContainer_user = {|
  +id: string,
  +$refType: NotesWidgetContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "NotesWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ffa584151975cac7a92e5c62231e6b1b';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Widget/Widgets/Notes/__generated__/NotesWidgetContainer_user.graphql.js